module.exports = [
  {
    "geo": "United States",
    "LE": 78.67
  },
  {
    "geo": "Louisiana",
    "LE": 75.9
  },
  {
    "geo": "Metro New Orleans",
    "LE": 76.55
  },
  {
    "geo": "City of New Orleans",
    "LE": 75.86
  }
]
